const states = [
  'bundle_start',
  'bundle_data_load',
  'bundle_scripts_load'
];

export function getDistance(preloadState) {
  const distance = states.findIndex(state => state === preloadState);
  return distance !== -1 ? distance : 3;
}

export function getState(preloadDistance) {
  return states[preloadDistance] || 'hidden';
}
